import * as Sentry from '@sentry/browser';
import { useQuery } from '@tanstack/react-query';

import InclusionsService from '~/services/InclusionsService';

import { inclusionsQueryKeys } from './inclusionsQueryKeys';

export interface PackageInclusion {
  id: string;
  name: string;
  description: string;
  rrp: number | null;
  total_value: number | null;
  type: string;
  currencyisocode: string;
}

interface UseFetchPackageInclusionsParams {
  offerId: string;
  dealSalesforceId: string;
  currencyisocode: string;
  enabled?: boolean;
}

export function useFetchPackageInclusions({
  offerId,
  dealSalesforceId,
  currencyisocode,
  enabled = true,
}: UseFetchPackageInclusionsParams) {
  return useQuery({
    queryKey: inclusionsQueryKeys.packageInclusionsByDeal(offerId, dealSalesforceId, currencyisocode),
    queryFn: async () => {
      try {
        const inclusionsResponse = await InclusionsService.fetchPackageInclusions(offerId);
        const inclusionsForDeal = inclusionsResponse.result[dealSalesforceId] || [];

        const inclusionsForDealMapped: PackageInclusion[] = inclusionsForDeal.map((obj) => {
          const inclusion = obj.inclusion;
          return {
            id: inclusion.id,
            description: inclusion.description,
            rrp: inclusion.rrp,
            total_value: inclusion.total_value,
            type: inclusion.type,
            name: inclusion.name,
            currencyisocode: currencyisocode,
          };
        });

        return inclusionsForDealMapped;
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            hook: 'useFetchPackageInclusions',
            offerId,
          },
        });
        return [];
      }
    },
    enabled: enabled && !!offerId,
  });
}
